import React from 'react';

function RicercaUte(props) {
  return (
    <div className='row'>
      <div className='col-sm-3'>
        <div className='show-entries'>
          <span>Mostra</span>
          <select className='form-control'>
            <option>10</option>
            <option>15</option>
            <option>20</option>
            <option>50</option>
          </select>
          <span>righe</span>
        </div>
      </div>
      <div className='col-sm-9'>
        <button type='button' className='btn btn-primary' onClick={props.Cerca}>
          <i className='fa fa-search'></i>
        </button>
        <div className='filter-group'>
          <label>Filtro: </label>
          <input
            name='nome'
            type='text'
            className='form-control'
            onChange={props.GestMod}
            onKeyDown={props._handleKeyDown}
            onFocus={props.onFocusCerca}
            value={props.nome}
          />
        </div>
      </div>
    </div>
  );
}

export default RicercaUte;
